<template>
  <button
    :type="type"
    :disabled="disabled"
    class="button"
    :class="`button--${variant}`"
    v-bind="$attrs"
    @click="handleActivate"
    @keydown.enter.prevent="handleActivate"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
export type ButtonVariant = "primary" | "secondary" | "danger";

const props = withDefaults(
  defineProps<{
    type?: "button" | "submit" | "reset";
    variant?: ButtonVariant;
    disabled?: boolean;
    href?: string; // href has precedence over click event
  }>(),
  {
    type: "button",
    variant: "secondary",
    disabled: false,
    href: undefined,
  },
);

const emit = defineEmits<{
  click: [event: MouseEvent | KeyboardEvent];
}>();

const router = useRouter();

const handleActivate = (event: MouseEvent | KeyboardEvent) => {
  if (props.disabled) return;
  if (props.href) {
    router.push(props.href);
  }
  emit("click", event);
};
</script>
<style scoped lang="scss">
@use "@/sass/components/StoreButton.scss";
</style>
